import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { AccordionModule } from "primeng/accordion";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { VariantsListingComponent } from "../variants-listing/variants-listing.component";
import { CommonModule } from "@angular/common";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { PanelModule } from "primeng/panel";

@Component({
  selector: "jni-product-summary",
  templateUrl: "./product-summary.component.html",
  styleUrls: ["./product-summary.component.scss"],
  imports: [
    AccordionModule,
    ReactiveFormsModule,
    ModalStackerComponent,
    VariantsListingComponent,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    PanelModule,
  ],
})
export class ProductSummaryComponent implements OnInit {
  @Input() productSummaryDetail: ReleasedProduct = {} as ReleasedProduct;
  @Output() closeModalEvent = new EventEmitter();
  generalDetailForm!: FormGroup;
  financialDimensionForm!: FormGroup;
  variantsListingModal = false;
  showFinancialDimensions = false;

  selectedVariantItemNumber = "";

  constructor(
    private _fb: FormBuilder,
    private _loginService: UserManagementService
  ) {
    this.createForm();
    this.patchValuesIntoDetailsForm();
  }

  createForm() {
    this.generalDetailForm = this._fb.group({
      identification: this._fb.group({
        productType: [{ value: "", disabled: true }],
        productSubtype: [{ value: "", disabled: true }],
        productServiceType: [{ value: "", disabled: true }],
        itemNumber: [{ value: "", disabled: true }],
        productNumber: [{ value: "", disabled: true }],
      }),
      furtherIdentification: this._fb.group({
        productName: [{ value: "", disabled: true }],
        searchName: [{ value: "", disabled: true }],
        description: [{ value: "", disabled: true }],
        unit: [{ value: "", disabled: true }],
        salesPrice: [{ value: "", disabled: true }],
        projectCategory: [{ value: "", disabled: true }],
      }),
      administration: this._fb.group({
        storageDimensionGroup: [{ value: "", disabled: true }],
        trackingDimensionGroup: [{ value: "", disabled: true }],
        itemModelGroup: [{ value: "", disabled: true }],
        reservationHierarchy: [{ value: "", disabled: true }],
        countingPolicy: [{ value: "", disabled: true }],
        productLifeCycleState: [{ value: "", disabled: true }],
        advancedLifeCycle: [{ value: "", disabled: true }],
      }),
      storageDefaults: this._fb.group({
        jniStore: [{ value: "", disabled: true }],
        warehouse: [{ value: "", disabled: true }],
        wmsOwner: [{ value: "", disabled: true }],
        productType: [{ value: "", disabled: true }],
        jniLowstockLevel: [{ value: "", disabled: true }],
        site: [{ value: "", disabled: true }],
        defaultReceiptLocation: [{ value: "", disabled: true }],
        defaultIssueLocation: [{ value: "", disabled: true }],
      }),
    });

    this.financialDimensionForm = new FormGroup({
      department: new FormControl({ value: "", disabled: true }),
      location: new FormControl({ value: "", disabled: true }),
      productCategory: new FormControl({ value: "", disabled: true }),
      productSubCategory: new FormControl({ value: "", disabled: true }),
      program: new FormControl({ value: "", disabled: true }),
    });
  }

  ngOnInit() {
    this.patchValuesIntoDetailsForm();
    this.validateLogin();
  }

  onKeyDown(event: Event) {
    event.preventDefault();
  }

  patchValuesIntoDetailsForm() {
    this.generalDetailForm.patchValue({
      identification: {
        productType: this.productSummaryDetail.productTypeD365,
        productSubtype: this.productSummaryDetail.productSubTypeD365,
        productServiceType: this.productSummaryDetail.productTypeD365,
        itemNumber: this.productSummaryDetail.itemNumberD365,
        productNumber: this.productSummaryDetail.productNumberD365,
      },
      furtherIdentification: {
        productName: this.productSummaryDetail.nameD365,
        searchName: this.productSummaryDetail.searchNameD365,
        description: this.productSummaryDetail.descriptionD365,
        unit: this.productSummaryDetail.salesUnitSymbolD365,
        salesPrice: this.productSummaryDetail.salesPriceD365,
        projectCategory: this.productSummaryDetail.projectCategoryIdD365,
      },
      administration: {
        storageDimensionGroup:
          this.productSummaryDetail.storageDimensionGroupNameD365,
        trackingDimensionGroup:
          this.productSummaryDetail.trackingDimensionGroupNameD365,
        itemModelGroup: this.productSummaryDetail.itemModelGroupIdD365,
        // reservationHierarchy: this.productSummaryDetail.reserva
        // countingPolicy: this.productSummaryDetail.reason
        // productLifeCycleState: this.productSummaryDetail.
        // advancedLifeCycle: this.productSummaryDetail.advancedLifeCycle
      },
      storageDefaults: {
        jniStore: this.productSummaryDetail.storeD365,
        productType: this.productSummaryDetail.productTypeD365,
        warehouse: this.productSummaryDetail.warehouseD365,
        site: this.productSummaryDetail.siteD365,
        wmsOwner: this.productSummaryDetail.ownerD365,
        jniLowstockLevel: this.productSummaryDetail.lowStockLevelD365,
        defaultReceiptLocation:
          this.productSummaryDetail.defaultReceiptLocationD365,
        defaultIssueLocation:
          this.productSummaryDetail.defaultIssueLocationD365,
      },
    });
    this.financialDimensionForm.patchValue({
      department: this.productSummaryDetail.departmentD365,
      location: this.productSummaryDetail.locationD365,
      productCategory: this.productSummaryDetail.productCategoryD365,
      productSubCategory: this.productSummaryDetail.productSubCategoryD365,
      program: this.productSummaryDetail.programD365,
    });
  }

  showVariants() {
    if (this.productSummaryDetail?.itemNumberD365) {
      this.selectedVariantItemNumber =
        this.productSummaryDetail?.itemNumberD365;
      this.variantsListingModal = true;
    }
  }

  closeModalForVariantsListing() {
    this.variantsListingModal = false;
  }

  validateLogin() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res?.status === "Success" && res?.data?.userRoleId) {
          if (res.data.userRoleId === UserRole.Admin) {
            this.showFinancialDimensions = true;
          }
        }
      });
  }

  onCloseModal() {
    this.closeModalEvent.emit();
  }
}
